import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { FC } from 'react';
import './Header.scss';
import { EntryPointClietWrapper } from '../entry-point/EntryClientWrapper';
import { LanguageCode } from '@/hotdesk-ui/constants/langulage.constant';
import DarkNavbarClientWrapper from '../dark-nav-bar/DarkNavbarClientWrapper';
import BannerClientWrapper from '../banner/BannerClientWrapper';
interface HeaderProps {
  isDirectory: boolean;
  isunleashFetched: boolean;
  book_btn_par: string;
  appQRCode: (clicked: string) => void;
  moveToExternalLink: (link: string, event: string) => void;
  team_btn_par: string;
  languageCode: LanguageCode;
  isBannerVisible: boolean;
  handleCloseBanner: () => void;
  emiratesCta: boolean;
}
const Header: FC<HeaderProps> = ({
  isDirectory,
  isunleashFetched,
  book_btn_par,
  appQRCode,
  moveToExternalLink,
  team_btn_par,
  languageCode,
  isBannerVisible,
  handleCloseBanner,
  emiratesCta
}) => {
  const t = useTranslations();
  return <>
            {emiratesCta && isBannerVisible && <BannerClientWrapper languageCode={languageCode} handleCloseBanner={handleCloseBanner} />}
            <div id="header">
                <DarkNavbarClientWrapper languageCode={languageCode} isDirectory={isDirectory} style="navbarLight" isBannerVisible={isBannerVisible} data-sentry-element="DarkNavbarClientWrapper" data-sentry-source-file="Header.tsx" />
                <header className="container">
                    <div className="row">
                        <div className="col-12" id="first_sec">
                            <div className="text">
                                <h2 className="font-weight-bolder">
                                    {t('header.title')}
                                </h2>
                                {!!isDirectory && isunleashFetched && <div className="buttons pt-3 w-100 d-flex justify-content-center">
                                        <EntryPointClietWrapper languageCode={languageCode} />
                                    </div>}
                                {!isDirectory && isunleashFetched && <div className="buttons pt-3">
                                        {!!book_btn_par && <button className="btn btn_primary" onClick={() => {
                  appQRCode('book_now_clicked');
                }}>
                                                {book_btn_par}
                                            </button>}
                                        {!!team_btn_par && <button className="btn mx-md-2 mx-0" onClick={() => {
                  moveToExternalLink('/contact', 'setup_team_clicked');
                }}>
                                                {team_btn_par}
                                            </button>}
                                    </div>}
                                <div className="app pt-4 d-flex justify-content-center" onClick={event => {
                event.stopPropagation();
                appQRCode('download_app_hero_clicked');
              }}>
                                    <Image src="https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/web_v2/icons/g_play.svg" className="px-2" loading="lazy" width={36} height={31} alt="google_play" data-sentry-element="Image" data-sentry-source-file="Header.tsx" />
                                    <Image src="https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/web_v2/icons/apple.svg" loading="lazy" width={21} height={31} alt="apple-store" data-sentry-element="Image" data-sentry-source-file="Header.tsx" />
                                    <p className="m-0 p-0 px-2">
                                        {t('header.getApp')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
        </>;
};
export default Header;